import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable, filter, map } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models';

import { BookingSummaryBound } from '../../../interfaces';
import { isBusOrTrain } from '../../../utils/common-booking.utils';
import { isFlight } from '../../../utils/flight.utils';

@Component({
  selector: 'fin-booking-summary-flight',
  styleUrls: ['./booking-summary-flight.component.scss'],
  templateUrl: './booking-summary-flight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingSummaryFlightComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  bound$: Observable<BookingSummaryBound>;
  @Input()
  title: string;

  flights$: Observable<FinnairItineraryItemFlight[]>;
  icon$: Observable<SvgLibraryIcon>;
  ngOnInit(): void {
    this.flights$ = this.bound$.pipe(
      filter(Boolean),
      map((bound) =>
        bound.itinerary.filter(isFlight).map((i) => ({
          ...i,
          cabinClass: isBusOrTrain(i) ? null : i.cabinClass,
        }))
      )
    );
    this.icon$ = this.bound$.pipe(
      map((bound) =>
        bound.itinerary?.filter(isFlight).some((itinerary) => isBusOrTrain(itinerary))
          ? SvgLibraryIcon.MINUS
          : SvgLibraryIcon.AIRCRAFT_HORIZONTAL
      )
    );
  }
}
